module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/04-f280ef4796c568c0f39a109f8872c8b3.jpg";